import React from 'react';
export function Problem() {
  return <section className="py-16 px-4 bg-[#EFE4CC]" data-id="element-214">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-215">
        {/* Intro Problem */}
        <div className="space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-216">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-217">
            El problema no es que no te importa. Es que no sabés qué hacer.
          </h3>

          <p data-id="element-218">
            La escena se repite. En el almuerzo del domingo tu papá o tu mamá
            empieza a contar algo, se detiene en el medio, se ríe y dice "uy, se
            me fue". Todos siguen como si nada. Pero vos te quedaste pensando.
          </p>

          <p data-id="element-219">
            Porque no es la primera vez. Olvidan nombres, turnos del médico,
            dónde dejaron las llaves o si ya tomaron la medicación. Y lo más
            angustiante no es el olvido: es no saber si es normal, si va a
            empeorar, ni qué podés hacer vos como hijo, nieto o familiar.
          </p>

          <p data-id="element-220">
            Encima la vida no para. Trabajás, tenés tus obligaciones, no podés
            estar todos los días con ellos. Y cuando los ves, querés hacer algo
            concreto, no solo preocuparte.
          </p>
        </div>

        {/* What happens in most families */}
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-orange-200 shadow-md space-y-6 text-lg text-slate-700" data-id="element-221">
          <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-222">
            Lo que pasa en la mayoría de las familias argentinas
          </h3>

          <p data-id="element-223">
            Algunos esperan a ver si mejora solo. Otros lo llevan al médico y
            les dicen "es la edad". Otros buscan en Google y se pierden entre
            estudios en inglés o apps que el adulto mayor nunca va a usar.
          </p>
          <p className="font-semibold text-slate-900" data-id="element-224">
            Y casi todos terminan haciendo nada. No por falta de amor, sino
            porque no saben qué hacer ni cómo.
          </p>
          <p data-id="element-225">
            Mientras tanto el adulto mayor sigue solo en casa, con la tele de
            fondo, sin nada que lo desafíe mentalmente.
          </p>
          <p className="text-teal-700 font-medium italic" data-id="element-226">
            Y el cerebro, como cualquier músculo que no se usa, se va apagando
            de a poco.
          </p>
        </div>

        {/* The real problem */}
        <div className="space-y-8" data-id="element-227">
          <h3 className="text-3xl font-bold text-slate-900 text-center mb-10" data-id="element-228">
            El verdadero problema de la estimulación cognitiva en Argentina
          </h3>

          <p className="text-xl text-center text-slate-700 mb-6" data-id="element-229">
            El cerebro no envejece solo por los años. Envejece por la falta de
            uso.
          </p>

          <p className="text-lg text-slate-600 mb-8" data-id="element-230">
            Hay tres razones por las que las familias argentinas no logran
            trabajar esto en casa:
          </p>

          <div className="space-y-6" data-id="element-231">
            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-232">
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-233">
                Razón 1: No existe un sistema simple y adaptado a nuestra
                realidad.
              </h4>
              <p className="text-slate-700" data-id="element-234">
                Todo está pensado para profesionales o clínicas. No hay nada
                claro y listo para usar en casa sin conocimiento previo.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-235">
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-236">
                Razón 2: Los ejercicios genéricos los hacen sentir "enfermos".
              </h4>
              <p className="text-slate-700" data-id="element-237">
                Son aburridos y clínicos. Un abuelo evaluado no participa. Uno
                que se siente protagonista de algo valioso, sí.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl border-l-4 border-teal-600 shadow-sm" data-id="element-238">
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-239">
                Razón 3: La familia no sabe cómo involucrarse sin que parezca
                terapia.
              </h4>
              <p className="text-slate-700" data-id="element-240">
                Querés ayudar pero no incomodar. Y terminás sin hacer nada por
                miedo a que se sienta señalado.
              </p>
            </div>
          </div>

          <div className="text-center pt-8 space-y-4" data-id="element-241">
            <p className="text-2xl font-bold text-slate-900" data-id="element-242">
              No es falta de amor. No es falta de voluntad.
            </p>
            <p className="text-xl text-teal-700 font-medium" data-id="element-243">
              Es falta de un sistema que funcione de verdad para familias
              argentinas reales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}